import { SVGProps, Ref, forwardRef } from 'react';

export const PauseFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 21c2.625 0 3-.375 3-3V6c0-2.625-.375-3-3-3s-3 .375-3 3v12c0 2.625.375 3 3 3m9 0c2.625 0 3-.375 3-3V6c0-2.625-.375-3-3-3s-3 .375-3 3v12c0 2.625.375 3 3 3"
                fill="currentColor"
            />
        </g>
    </svg>
));
PauseFilledSize24Glyph.displayName = 'PauseFilledSize24Glyph';
